import React, {Fragment} from "react";

export default class OrderPayProvider extends React.Component {
    render() {
        return <Fragment/>
    }
}